import { Upload, X } from "lucide-react";

const ResumeUploader = ({ file, onSelect, onClear }) => {
    if (file) {
        return (
            <div
                data-testid="resume-upload-summary"
                className="flex items-center justify-between border border-border bg-card px-5 py-4"
            >
                <div className="min-w-0">
                    <p className="truncate font-sans text-sm font-medium text-foreground">{file.name}</p>
                    <p className="text-xs text-muted-foreground">
                        {(file.size / 1024).toFixed(0)} KB · ready to upload
                    </p>
                </div>
                <button
                    type="button"
                    onClick={onClear}
                    data-testid="resume-clear"
                    className="ml-4 inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground"
                >
                    <X size={14} strokeWidth={1.5} />
                    Remove
                </button>
            </div>
        );
    }
    return (
        <label
            data-testid="resume-upload-dropzone"
            className="flex cursor-pointer items-center gap-4 border border-dashed border-border bg-card px-5 py-6 transition-colors hover:border-foreground"
        >
            <Upload size={20} strokeWidth={1.5} className="text-foreground" />
            <div>
                <p className="font-sans text-sm font-medium">Upload your resume</p>
                <p className="text-xs text-muted-foreground">PDF, DOC, or DOCX up to 8MB</p>
            </div>
            <input
                type="file"
                className="sr-only"
                accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                onChange={onSelect}
            />
        </label>
    );
};

export default ResumeUploader;
